var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:[
        'ccos__systems-space',
        {
            'ccos__systems-space--showing': _vm.showing,
        }
    ],on:{"click":function($event){return _vm.$emit('click')}}},[_c('Counter',{staticClass:"systems-space__counter"},[_vm._v(" "+_vm._s(_vm.suggestion.systems.length)+" ")]),_c('div',{staticClass:"systems-space__names"},_vm._l((_vm.suggestion.toolSpaceIds),function(toolSpaceId){return _c('strong',{key:toolSpaceId,staticClass:"systems-space__name ccos-heading-space"},[_vm._v(" "+_vm._s(_vm.getSpaceName(toolSpaceId))+" ")])}),0),(_vm.valid)?_c('Selected',{staticClass:"systems-space__selected"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }